import React from 'react';
import Header from '../components/Header';

class ProfileEdit extends React.Component {
  render() {
    return (
      <div data-testid="page-profile-edit">
        <Header />
        <p>ESTOU NO ProfileEdit</p>
      </div>
    );
  }
}

export default ProfileEdit;
